module.exports = __webpack_public_path__ + "static/media/red_tabs.6414056b.svg";